export function faqLink(language?: string): string {
  // english is the default language in the astro config so it doesn't have a locale prefix
  if (!language || language.toLowerCase() === "en") {
    return "https://dockethealth.com/faqs";
  }
  return `https://dockethealth.com/${language.toLowerCase()}/faqs`;
}
